<template>
  <div v-if="requestFriend.is_requested===1" class="position-relative">
    <div class="position-absolute d-flex  align-items-center "
         style="z-index: 2;width: 100%; height: 48px; background-color: white;  border-bottom: 1px solid #e0e4e8;">
      <div class="text-normal ms-3 me-2 flex-1 text-center fw-semibold">Đã gửi lời mời kết bạn</div>
      <el-button class="me-3" plain type="danger" size="mini" @click="undoFriendRequest"> Thu hồi</el-button>
    </div>
  </div>
  <div v-else-if="data.isFr === 0" class="position-relative">
    <el-dialog top="2vh" v-if="replaceBadWord.show"
               :title="'Tin nhắn gửi đi có chứa '+replaceBadWord.items.length+' từ khóa nhạy cảm'" width="500px"
               :visible.sync="replaceBadWord.show"
               :close-on-click-modal="false"
               :destroy-on-close="true">
      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px;overflow-y: auto;">
            <div v-for="(item,index) in replaceBadWord.items" :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input placeholder="Nội dung thay thế" @input="handleInputReplace(item)"
                            v-model="item.replace"></el-input>
                </div>

              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2 ">Nội dung sau chỉnh sửa</div>
        <el-input
          ref="inputText"
          resize="none"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 5}"
          v-model="replaceBadWord.content"
          disabled
        />
        <div class="d-flex justify-content-end mt-2">
          <el-button size="sm" plain type="danger" @click="closeReplaceBadWord()">Hủy</el-button>
          <el-button size="sm" type="primary" @click="sendReplace()">Gửi tin nhắn</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      v-if="visibleRequestFriend"
      :visible.sync="visibleRequestFriend"
      title="Gửi yêu cầu kết bạn"
    >
      <div class="p-2">
        <el-input type="textarea" row="3" v-model="textRequestFriend"></el-input>
        <div class="d-flex justify-content-end align-items-center mt-3 ">
          <el-button plain type="danger" @click="visibleRequestFriend = false" size="small"> Huỷ</el-button>
          <el-button plain type="primary" @click="addFriend()" size="small"> Xác nhận</el-button>
        </div>
      </div>

    </el-dialog>
    <div class="position-absolute d-flex  align-items-center "
         style="z-index: 2;width: 100%; height: 48px; background-color: white;  border-bottom: 1px solid #e0e4e8;">
      <div class="text-normal ms-3 me-2 flex-1 fw-semibold">Gửi yêu cầu kết bạn tới người này</div>
      <div>

        <el-button size="mini" class="me-3" plain @click="showPopup()">Gửi kết bạn</el-button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "RequestFriendBox",
  props: {
    data: Object,
    conversation: Object
  },
  data() {
    return {
      visibleRequestFriend: false,
      requestFriend: {},
      textRequestFriend: "Xin chào kết bạn với mình nhé!",
      replaceBadWord: {
        show: false,
        items: [],
        content: ""
      }
    };
  },
  computed: {
    getName() {
      if (this.conversation.swName !== null && this.conversation.swName.length > 0) {
        return this.conversation.swName;
      } else {
        return this.conversation.toName;
      }
    }

  },
  methods: {

    showPopup() {
      this.visibleRequestFriend = true;
    },
    closeReplaceBadWord() {
      this.replaceBadWord.show = false;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr()) {

          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    deleteReplace(item) {
      let filter = this.replaceBadWord.items.filter((con) => con.key == item.key);
      if (filter != null && filter.length > 0) {
        const index = this.replaceBadWord.items.indexOf(filter[0]);
        if (index > -1) {
          this.replaceBadWord.items.splice(index, 1);
          this.replaceBadWordContent();
        }
      }
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.conversation.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map(item => [item[key], item])).values()];
      return unique;
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.textRequestFriend;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter(p => p.accountId == this.conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.textRequestFriend;
        let arr = text.split(" ");
        if (this.filterCharacterArr() && this.filterCharacterArr().length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr()) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    async addFriend() {
      let items = this.filterCharacter();
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.send();
      }
    },
    sendReplace() {
      this.textRequestFriend = this.replaceBadWord.content;
      this.send();
    },
    send() {
      this.visibleRequestFriend = false;
      this.$http.get("/api/contact/addFriend", {
        params: {
          userId: this.conversation.toId,
          accountId: this.conversation.accountId,
          msg: this.textRequestFriend
        }
      }).then(async (resp) => {
        if (resp.data.error_code === 0) {
          let data = await this.friendRequestStatus();
          if (data.is_requested === 1) {
            this.alert("success", "Gửi kết bạn thành công");
          } else {
            this.alert("error", "Người dùng này đã từ chối trước đó");
          }
        } else if (resp.data.error_code === 222) {
          this.$set(this.data, "isFr", 1);
        } else if (resp.data.error_code !== 0) {
          return this.alert("error", resp.data.error_message);
        }
      });
    },
    async friendRequestStatus() {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId
      };
      return this.$http.post("/api/conversation/friendRequestStatus", request).then((resp) => {
        if (resp.data.error_code === 0) {
          this.requestFriend = resp.data.data;
        }
        return resp.data.data;
      });
    },
    undoFriendRequest() {
      this.$http.get("/api/contact/undoFriendRequest", {
        params: {
          accountId: this.conversation.accountId,
          userId: this.conversation.toId
        }
      }).then((resp) => {
        if (resp.data.error_code === 0) {
          this.friendRequestStatus();
        }
        if (resp.data.error_code !== 0) {
          this.alertError(resp.data.error_message);
        }
        // this.alert("success", "Thao tác thành công");
      });
    }
  },
  mounted() {
    if (this.data.isFr === 0) {
      this.friendRequestStatus();
    }
    this.textRequestFriend = "Xin chào " + this.getName + ", kết bạn với mình nhé!";
  }
};
</script>

<style scoped>

</style>
